/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';

import CompanyInfo from "../components/includes/CompanyInfo";
import Footer from "../components/includes/Footer";

import rightArrowIcon from "../img/icon/icon-arrow-right-bar.svg";
import logoIcon from "../img/logo/logo.png";
import megaphoneIcon from "../img/icon/icon-isometric-megaphone.svg";

import { ChangeSearchingDateFormat, isEmptyObj,ShowDeliveryStatus,SetClassDeliveryStatus } from "../components/common/Common";

import "../css/style.css";

const Main = () => {
  const mem_idx = Number(localStorage.getItem("mem_idx"));
  const mem_name = localStorage.getItem("mem_name");
  const mem_carnumb = localStorage.getItem("mem_carnumb");
  const isLoginUser = Number(localStorage.getItem("userLoginState"));

  const navigator = useNavigate();

  //배차현항
  const [varDeliveryToday,setDeliveryToday] = useState(0);
  const [varDeliveryList,setDeliveryList] = useState([]);
  //공지사항 제목
  const [varNoticeList,setNoticeList] = useState([]);
  const [varNoticeTotal,setNoticeTotal] = useState(0);
  const [varNoticeCurrentIndex,setNoticeCurrentIndex] = useState(0);
  const [varNoticeInfo,setNoticeInfo] = useState({});
  
  //배차현황+공지사항 정보 호출
  const GetDeliveryList = async() => {
    const today = new Date();
    const dc_rdate = ChangeSearchingDateFormat(today,'-');
    const sendData = {mem_idx:mem_idx,dc_rdate:dc_rdate};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_main_state`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setDeliveryList(datas.results);
        if(datas.notices?.length > 0) {
          setNoticeList(datas.notices);
          setNoticeInfo(datas.notices[0]);
          setNoticeTotal(datas.notices.length);
          setNoticeCurrentIndex(0);
        }
        setDeliveryToday(datas.tcount);
      }
    });
  }

  useEffect(() => {
    GetDeliveryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //공지사항 이전/이후 정보 보기
  const onChangeNoticePrevHandler = (e,ino) => {
    let newNum = varNoticeCurrentIndex + ino;
    if(newNum < 0) newNum = varNoticeTotal - 1;
    else if(newNum === varNoticeTotal) newNum = 0;
    console.log(ino,newNum);
    const newData = varNoticeList[newNum];
    setNoticeInfo(newData);
    setNoticeCurrentIndex(newNum);
  }
  const onShowNoticePageHandler = (e) => {
    const board_idx = varNoticeInfo.board_idx;
    navigator(`/NoticeView/${board_idx}`);
  }

  return(
    <div className="vh-container">
      {/* <Header varGoToMain={-1} /> */}
      <div className="vh-content">
        <div className="main-content-wrap">
          {/* 로그인전 */}
          {isLoginUser?
            <div className="main-wellcome-visual mb20">
              <div className="logo"><img src={logoIcon} alt="" /></div>
              <div className="wellcome-text mt-auto">
                <div className="title mb10">안녕하세요! {mem_name} 님,</div>
                <div className="user-driver-num">{mem_carnumb}</div>
              </div>
            </div>
          :
            <div className="main-wellcome-visual mb20">
              <div className="logo"><img src={logoIcon} alt="" /></div>
              <div className="wellcome-text mt-auto mb30">
                <div className="title mb10">안녕하세요!</div>
                <div>로그인하시면 더욱 다양한<br/>서비스를 이용하실 수 있습니다.</div>
              </div>
              <Link to="/Login" className="wellcome-sign">
                <span>로그인하기</span>
                <div className="icon"><img src={rightArrowIcon} alt=""/></div>
              </Link>
            </div>
          }
          {/* 공지 */}
          {isEmptyObj(varNoticeInfo)?null:
            <div className="main-content-body">
              <div className="notice-wrap bd-t mb20">
                <div className="notice-head mb10">
                  <div className="icon-title">
                    <div className="icon"><img src={megaphoneIcon} alt="" /></div>
                    <Link to={'/Notice'}><span>공지</span></Link>
                  </div>
                  <div className="notice-controller">
                    <div className="notice-prev" onClick={e=>onChangeNoticePrevHandler(e,-1)}></div>
                    <div className="notice-next active" onClick={e=>onChangeNoticePrevHandler(e,1)}></div>
                  </div>
                </div>
                <div className="notice-body">
                  <div className="notice-prev-bar" onClick={onShowNoticePageHandler}>{varNoticeInfo.board_title}</div>
                </div>
              </div>
            </div>
          }
          {/* 금일배차횟수 */}
          {!isLoginUser?null:
            <>
              <div className="driving-today-total mb20">
                <div className="driving-total-bar">
                  <div>금일 배차 건수</div>
                  <div className="total-num">
                    <strong>{varDeliveryToday}</strong>
                    <span className="unit">&nbsp;&nbsp;건</span>
                  </div>
                </div>
                <Link to={`/DeliveryState`} className="link-btn">배차현황<br/>바로가기</Link>
              </div>
              {/* 금일 배차 목록 */}
              <div className="driving-today-wrap mb20">
                <div className="driving-today-title">금일 배차 리스트</div>
                <div className="driving-today-head">
                  <div className="th" style={{width:'40%'}}>상차지</div>
                  <div className="th" style={{width:'40%'}}>하차지</div>
                  <div className="th" style={{width:'20%'}}>운송현황</div>
                </div>
                <ul className="driving-today-body">
                  {varDeliveryList.map((delivery,i)=>(
                    <li key={'delivery_'+i}>
                      <div className="td" style={{width:'40%'}}>{delivery.dc_riding_address}</div>
                      <div className="td" style={{width:'40%'}}>{delivery.dc_quit_address}</div>
                      <Link to={`/DeliveryDetail/${delivery.dc_idx}`} style={{width:"20%"}}>
                        <div className="td" style={{width:"auto"}}>
                          <div className={SetClassDeliveryStatus(delivery.dc_status)}>{ShowDeliveryStatus(delivery.dc_status)}</div>
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          }
          <CompanyInfo/>
        </div>
        <Footer varActiveMode={1}/>  
      </div>  
    </div>
  );
}
export default Main;